import type { FC, SelectHTMLAttributes } from "react";
import * as Styled from "./Select.styled";
export const Select: FC<SelectHTMLAttributes<HTMLSelectElement>> = ({
  children,
  ...props
}) => {
  return <Styled.Select {...props} data-sentry-element="unknown" data-sentry-component="Select" data-sentry-source-file="index.tsx">{children}</Styled.Select>;
};